import React, { useContext } from 'react';
import 'twin.macro';
import { PreferenceContext, updateTheme } from '../context';
import { DropDown, DropDownItem } from '../dropdown';
import { gaEvent } from 'services/ga';
import { deleteCookie, documentGetCookie } from '../../cookie';

const themeName = (active) => {
  return active === 'light' ? 'licht' : active === 'dark' ? 'donker' : active;
};

export const changeTheme = (theme = 'dark', preference, setPreference) => {
  const oldThemeCookie = !!documentGetCookie('theme');
  setPreference({ theme: oldThemeCookie ? documentGetCookie('theme') : theme });
  if (oldThemeCookie) {
    deleteCookie('theme');
  }
  updateTheme(theme);
};

export const ThemeSwitcher = ({ isRight = false }) => {
  const {
    preference,
    preference: { theme },
    setPreference,
  } = useContext(PreferenceContext);

  return (
    <DropDown label={`${themeName(theme)}`} isSelect isRight={isRight}>
      <DropDownItem
        label='Licht'
        selectedValue={theme === 'light'}
        onClick={() => {
          changeTheme('light', preference, setPreference);
          gaEvent('dmp_settings_change', 'theme_light');
        }}
      />
      <DropDownItem
        label='Donker'
        selectedValue={theme === 'dark'}
        onClick={() => {
          changeTheme('dark', preference, setPreference);
          gaEvent('dmp_settings_change', 'theme_dark');
        }}
      />
      {/* <DropDownItem 
        selectedValue={theme === 'dumpert'}
        onClick={() => setTheme('dumpert')}>
          Dumpert
  </DropDownItem> */}
    </DropDown>
  );
};
